import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ToastService } from '@web/shared/ui';
import { AdminRefundSettingsApiService } from '../api/services/admin-refund-settings-api.service';
import { AdminRefundSettingsFormData } from '../models/admin-refund-settings-form-data';
import { AdminRefundSettingsUpdateRequest } from '../api/requests/admin-refund-settings-update.request';

@Injectable({
  providedIn: 'root',
})
export class AdminRefundSettingsDataSourceService {
  private readonly refundSettingsApi = inject(AdminRefundSettingsApiService);
  private readonly toast = inject(ToastService);

  public fetchSettingsFormData(): Observable<AdminRefundSettingsFormData> {
    return this.refundSettingsApi.fetchSettings({ skipByLoading: true }).pipe(
      map(
        (response) =>
          new AdminRefundSettingsFormData({
            isCodEmailSent: response.isCodEmailSent,
            codMessageEmails: response.codMessageEmails,
          }),
      ),
    );
  }

  public updateSettingsByFormData(
    data: AdminRefundSettingsFormData,
  ): Observable<void> {
    return this.refundSettingsApi
      .updateSettings(
        new AdminRefundSettingsUpdateRequest({
          isCodEmailSent: data.isCodEmailSent,
          codMessageEmails: data.codMessageEmails,
        }),
      )
      .pipe(
        tap(() => {
          this.toast.show((builder) =>
            builder
              .initSuccess('Konfiguracja zwrotów została zaktualizowana.')
              .build(),
          );
        }),
      );
  }
}
